module.exports = __webpack_public_path__ + "static/media/e4.d6e4090e.png";